import React from "react";
import { Row } from "react-table";
import { TableCollapseFormat } from "../../types/Payroll.types";
import {
  BreakHeaderLabel,
  ClockInOutHeaderLabel,
  CollapseButtonWrapper,
  CollapseHeaderWrapper,
  DateHeaderLabel,
  TotalHoursHeaderLabel,
} from "./styledComponents";

export type TableCollapseGroupRowProps = {
  row: Row<TableCollapseFormat>;
  colSpan: number;
  style?: React.CSSProperties;
};

export const TableCollapseGroupRow = ({
  row,
  colSpan,
  style,
}: TableCollapseGroupRowProps) => {
  return (
    <tr {...row.getRowProps()} style={style}>
      <td colSpan={colSpan}>
        <CollapseHeaderWrapper>
          <DateHeaderLabel>{row.original.headerDate}</DateHeaderLabel>
          <ClockInOutHeaderLabel>Clock in And Clock out</ClockInOutHeaderLabel>
          <BreakHeaderLabel>Meal break(s)</BreakHeaderLabel>
          <TotalHoursHeaderLabel>
            Total hours {row.original.totalHours.toFixed(2)}
          </TotalHoursHeaderLabel>
          <CollapseButtonWrapper>
            <i
              className={`pi pi-angle-${row.isExpanded ? "up" : "down"}`}
              onClick={() => row.toggleRowExpanded()}
            />
          </CollapseButtonWrapper>
        </CollapseHeaderWrapper>
      </td>
    </tr>
  );
};
